const NotFoundIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="98"
    height="98"
    viewBox="0 0 98 98"
  >
    <defs>
      <path
        id="a"
        d="M.97 0l4.061 30.713c.086.65.595 1.165 1.252 1.268A1.497 1.497 0 0 0 8 30.754L12 0H.97z"
      />
      <filter
        id="b"
        width="137.5%"
        height="112.5%"
        x="-18.8%"
        y="-6.2%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dx="-3" in="SourceAlpha" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 0.631029212 0 0 0 0 0.0945221158 0 0 0 0 0.417948379 0 0 0 0.1 0"
        />
      </filter>
      <path
        id="c"
        d="M.97 32l4.061 30.713c.086.65.595 1.165 1.252 1.268A1.497 1.497 0 0 0 8 62.754L12 32H.97z"
      />
      <filter
        id="d"
        width="137.5%"
        height="112.5%"
        x="-18.8%"
        y="-6.2%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dx="-3" in="SourceAlpha" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 0.925583107 0 0 0 0 0.824717829 0 0 0 0 0.887758628 0 0 0 0.5 0"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(1 1)">
      <circle cx="48" cy="48" r="28" fill="#ECECEC" fillRule="nonzero" />
      <path
        fill="#ECECEC"
        fillRule="nonzero"
        stroke="#C9C9C9"
        d="M48 96.5C21.214 96.5-.5 74.786-.5 48S21.214-.5 48-.5 96.5 21.214 96.5 48 74.786 96.5 48 96.5zm0-7.588c22.595 0 40.912-18.317 40.912-40.912S70.595 7.088 48 7.088 7.088 25.405 7.088 48 25.405 88.912 48 88.912z"
      />
      <rect width="3" height="8" x="47" y="2" fill="#C9C9C9" rx="1.5" />
      <rect width="3" height="8" x="47" y="85" fill="#C9C9C9" rx="1.5" />
      <g fill="#C9C9C9" transform="rotate(90 23 70)">
        <rect width="3" height="8" rx="1.5" />
        <rect width="3" height="8" y="82" rx="1.5" />
      </g>
      <g transform="rotate(140 18.75 31.467)">
        <use fill="#E5ABCE" xlinkHref="#a" />
        <use fill="#000" filter="url(#b)" xlinkHref="#a" />
        <use stroke="#C03388" xlinkHref="#a" />
      </g>
      <g transform="rotate(-40 48.98 -17.697)">
        <use fill="#F8E8F2" xlinkHref="#c" />
        <use fill="#000" filter="url(#d)" xlinkHref="#c" />
        <use stroke="#C74995" xlinkHref="#c" />
      </g>
    </g>
  </svg>
)

export default NotFoundIcon
